<section class="purchase">
  <a routerLink="/" class="back">Tilbage</a>

  <img class="preview" [src]="apiAssetUrl + assetId" alt="Preview">

  <h1>Køb hi-res billede til print</h1>
  <p class="price" *ngIf="offer">{{ priceLabel }}</p>

  <form (ngSubmit)="pay()" novalidate>
<!--    <ng-container *ngIf="!usePhone; else phoneField">-->
      <label for="email">Email til download link</label>
      <input id="email" name="email" type="email" autocomplete="email"
             [(ngModel)]="email" [disabled]="busy" required>
<!--    </ng-container>-->

<!--    <ng-template #phoneField>-->
<!--      <label for="phone">Mobile number for your download link (SMS)</label>-->
<!--      <input id="phone" name="phone" type="tel" inputmode="numeric" autocomplete="tel"-->
<!--             placeholder="12 34 56 78" [(ngModel)]="phone" [disabled]="busy" required>-->
<!--    </ng-template>-->

<!--    <button type="button" class="link" (click)="toggleContact()" [disabled]="busy">-->
<!--      {{ usePhone ? 'Use email instead' : 'No email? Use your mobile number' }}-->
<!--    </button>-->

    <p class="error" role="alert" *ngIf="error">{{ error }}</p>

    <button type="submit" class="pay" [disabled]="busy">
      {{ busy ? 'Åbner MobilePay...' : 'Betal med MobilePay' }}
    </button>
  </form>

  <p class="note">Efter betaling får du et link til at download'e billedet (her og på email)</p>
</section>
